// import { log } from "../";

import * as React from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";

// Components
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import { SimpleInputForm } from "./SimpleInputForm";
import * as Icons from "../core/utils/Icons";

import { strings } from "../core/localizedStrings";
import { Colors } from "../core/utils/Colors";
import { StringUtils } from "../core/utils/StringUtils";

require("../styles/commonStyles.css");

// Layout
var Row = require("react-flexbox-grid").Row;
var Col = require("react-flexbox-grid").Col;

export interface SearchBoxProps extends React.Props<any> {
    initialValue?: string;
    disableUnderline?: boolean;
    fontSize: number;
    fontColor?: string;
    showLoading: boolean;
    placeholder?: string;
    hintColor?: string;
    hasBackground?: boolean;
    onSearchTextChange?: (text: string) => void;
    onCancel?: () => void;
}

@observer
export class SearchBox extends React.Component<SearchBoxProps> {
    private fontColor = Colors.white;
    private placeholder = strings.search;
    private hintColor = Colors.white;
    private hasBackground = true;
    private disableUnderline = false;

    private inputFormRef: SimpleInputForm;

    @observable
    private showCancelButton = false;

    constructor(props: any, context: any) {
        super(props, context);

        if (this.props.fontColor !== undefined) {
            this.fontColor = this.props.fontColor;
        }
        if (this.props.placeholder !== undefined) {
            this.placeholder = this.props.placeholder;
        }
        if (this.props.hintColor !== undefined) {
            this.hintColor = this.props.hintColor;
        }
        if (this.props.hasBackground !== undefined) {
            this.hasBackground = this.props.hasBackground;
        }
        if (this.props.disableUnderline !== undefined) {
            this.disableUnderline = this.props.disableUnderline;
        }
    }

    public render() {
        let iconSize = this.props.fontSize * 1.3;
        let backgroundOpacity = 0.0;
        if (this.hasBackground) {
            backgroundOpacity = 0.9;
        }

        let iconStyle = { marginTop: 2, color: this.props.fontColor, width: iconSize * 1.2, height: iconSize * 1.2 };

        let icon = <Icons.Search style={iconStyle} />;
        if (this.props.showLoading) {
            icon = <CircularProgress style={{ width: iconSize, height: iconSize }} />;
        } else if (this.showCancelButton) {
            icon = (
                <IconButton style={{ width: iconSize, height: iconSize, padding: 0 }} onClick={this.onCancelClicked}>
                    <CancelIcon
                        style={{ color: Colors.lightBlue, width: iconSize, height: iconSize }}
                        color="secondary"
                    />
                </IconButton>
            );
        }
        return (
            <Col
                xs={12}
                style={{ position: "relative", backgroundColor: Colors.rgba(255, 255, 255, backgroundOpacity) }}
            >
                <Row style={{ padding: "5px 0px 3px" }} middle="xs">
                    <SimpleInputForm
                        ref={instance => {
                            this.inputFormRef = instance;
                        }}
                        initialValue={this.props.initialValue}
                        disableUnderline={this.disableUnderline}
                        fontSize={this.props.fontSize}
                        fontColor={this.fontColor}
                        height={this.props.fontSize * 2}
                        hint={this.placeholder}
                        hintColor={this.hintColor}
                        onEnterDown={null}
                        onChange={this.onSearchTextChanged}
                    />
                    <div style={{ position: "absolute", right: iconSize / 2 }}>{icon}</div>
                </Row>
            </Col>
        );
    }

    @action
    private onCancelClicked = () => {
        if (this.inputFormRef !== undefined) {
            this.inputFormRef.clearInput();
            this.showCancelButton = false;
            this.props.onSearchTextChange(undefined);
        }
    };

    @action
    private onSearchTextChanged = (text: string) => {
        if (!StringUtils.isEmptyOrUndefined(text)) {
            this.showCancelButton = true;
        } else {
            this.showCancelButton = false;
        }

        if (this.props.onSearchTextChange !== undefined) {
            this.props.onSearchTextChange(text);
        }
    };
}
